import React from "react";
import { format } from "date-fns";

import Slider from "src/components/slider";
import Button from "src/components/button";
import Text from "src/components/text";

import { CustomFormField } from "src/types/settings/customFormFields";

import styles from "./styles.module.scss";

interface DeleteFormFieldProps {
  show: boolean;
  onClose: () => void;
  selectedField: CustomFormField | null;
  onConfirm: () => void;
  isDeleting: boolean;
}

const DeleteFormField: React.FC<DeleteFormFieldProps> = ({
  show,
  onClose,
  selectedField,
  onConfirm,
  isDeleting,
}) => {
  if (!selectedField) return null;

  const formatDate = (date: number | string) => {
    try {
      return format(new Date(date), "do MMM yyyy");
    } catch {
      return "—";
    }
  };

  return (
    <Slider.Dialog width="380" show={show} onClose={onClose}>
      <Slider.Header title="deleting" message={selectedField.name} />
      <Slider.Body>
        <div className={styles.body}>
          <p className={styles.description}>
            Are you sure you would like to delete this custom form field?
          </p>
          <div className={styles.information}>
            <div className={styles.title}>
              <Text
                text={selectedField.name}
                lines={1}
                className={styles.nameText}
                tooltip={{ placement: "auto" }}
              />
            </div>
            <div className={styles.meta}>
              <span>last updated: {formatDate(selectedField.modifiedDate)}</span>
            </div>
          </div>
        </div>
      </Slider.Body>
      <Slider.Actions>
        <Button
          variant="primary"
          icon="paperflite-tick"
          text={isDeleting ? "Deleting..." : "Confirm"}
          disabled={isDeleting}
          onClick={onConfirm}
        />
        <Button
          variant="secondary"
          text="Cancel"
          onClick={onClose}
          disabled={isDeleting}
        />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default DeleteFormField;
